import { resolveTrustedOfferOrigin } from './forkhire/offerModeCompatibility';

function normalizeRequiredHttpsOrigin(value: string | undefined, configurationName: string) {
  const configuredOrigin = String(value ?? '').trim();
  if (!configuredOrigin) throw new Error(`${configurationName}_required`);

  let url: URL;
  try {
    url = new URL(configuredOrigin);
  } catch {
    throw new Error(`${configurationName}_invalid`);
  }

  if (
    url.protocol !== 'https:' ||
    url.username ||
    url.password ||
    url.search ||
    url.hash ||
    (url.pathname !== '/' && url.pathname !== '')
  ) {
    throw new Error(`${configurationName}_invalid`);
  }

  return url.origin;
}

export function buildRecruitmentInterviewPath(token: string) {
  const cleanToken = token.trim();
  if (!cleanToken) throw new Error('interview_token_required');
  return `/interview/${encodeURIComponent(cleanToken)}`;
}

export function buildRecruitmentInterviewUrl(
  token: string,
  publicHireOrigin = import.meta.env.VITE_PUBLIC_HIRE_URL,
) {
  if (!String(publicHireOrigin ?? '').trim()) throw new Error('public_hire_url_required');
  const configuredHireOrigin = String(import.meta.env.VITE_PUBLIC_HIRE_URL ?? '').trim();
  const origin = resolveTrustedOfferOrigin({
    origin: publicHireOrigin,
    allowlist: configuredHireOrigin ? [configuredHireOrigin] : [],
  });
  return new URL(buildRecruitmentInterviewPath(token), `${origin}/`).toString();
}

export function buildInterviewPracticePath(sessionId: string) {
  const cleanSessionId = sessionId.trim();
  if (!cleanSessionId) throw new Error('practice_session_id_required');
  return `/seek/interview-practice/${encodeURIComponent(cleanSessionId)}`;
}

export function buildInterviewPracticeUrl(
  sessionId: string,
  publicSeekOrigin = import.meta.env.VITE_PUBLIC_SEEK_URL,
) {
  const origin = normalizeRequiredHttpsOrigin(publicSeekOrigin, 'public_seek_url');
  return new URL(buildInterviewPracticePath(sessionId), `${origin}/`).toString();
}
